import { render, staticRenderFns } from "./PageDeGarde.vue?vue&type=template&id=3846d77b&scoped=true&"
import script from "./PageDeGarde.vue?vue&type=script&lang=js&"
export * from "./PageDeGarde.vue?vue&type=script&lang=js&"
import style0 from "./PageDeGarde.vue?vue&type=style&index=0&id=3846d77b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846d77b",
  null
  
)

export default component.exports